import styles from "../../../styles/events.module.css";

function handleShare() {
  if (navigator.share) {
    navigator
      .share({
        title: "Inisa Grammar School Official Website",
        text: "This is the official website of Inisa Grammar School. Check out our latest events and updates!",
        url: " https://inisahighschool.iceiy.com/",
      })
      .then(() => console.log("Content shared successfully!"))
      .catch((error) => console.error("Error sharing:", error));
  } else {
    console.log("Web Share API is not supported in this browser.");
  }
}

const Events = () => {
  return (
    <div className={styles.eventssection}>
      <div className={styles.eventswrapper}>
        <div className={styles.eventscontainer}>
          <div className={styles.eventsbackground}></div>
          <div className={styles.events}>
            <h1 className={styles.eventstitle}>STUDENT</h1>
            <p className={styles.eventsdesc}>EVENTS</p>
          </div>
        </div>

        <div className={styles.eventscontainer}>
          <div className={styles.eventsbackground}></div>
          <div className={styles.events}>
            <h1 className={styles.eventstitle}>LABORATORY</h1>
            <p className={styles.eventsdesc}>EVENTS</p>
          </div>
        </div>

        <div className={styles.eventscontainer}>
          <div className={styles.eventsbackground}></div>
          <div className={styles.events}>
            <h1 className={styles.eventstitle}>TEACHERS</h1>
            <p className={styles.eventsdesc}>PROFILE</p>
          </div>
        </div>
      </div>
      <button className={`largebtn ${styles.darkbtn}`} onClick={handleShare}>
        Share Website
      </button>
    </div>
  );
};

export default Events;
